module.exports = __webpack_public_path__ + "static/media/dev-5.142e7818.png";